import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetOperatorsRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Account/GetUserOperators`,
	params: { userId }
});

export const UpdateSettingsRequest = (data) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Account/UpdateSettings`,
	data
});

export const ChangePasswordRequest = (data) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Account/ChangePassword`,
	data
});
